document.addEventListener('alpine:init', () => {
    Alpine.data('tabbedImage', (totalTabs) => ({
        activeTab: 0,
        touchStartX: 0,
        touchEndX: 0,
        totalTabs,

        calculateWidth() {
            const container = this.$refs.container;
            if (!container) {
                return;
            }

            const links = container.querySelectorAll('.tab-control');
            if (links.length === 0) {
                return;
            }

            const tabWidth = window.innerWidth * 0.65; // 65vw
            const totalWidth = links.length * tabWidth;

            container.style.width = `${totalWidth}px`;
        },

        calculateWidthMobile() {
            const container = this.$refs.mobileContainer;
            if (!container) {
                return;
            }

            const links = container.querySelectorAll('.tab-control');
            if (links.length === 0) {
                return;
            }

            const tabWidth = window.innerWidth * 0.65; // 65vw
            const totalWidth = links.length * tabWidth;

            container.style.width = `${totalWidth}px`;
        },

        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
        },

        handleTouchEnd(event) {
            this.touchEndX = event.changedTouches[0].clientX;
            this.handleSwipe();
        },

        handleSwipe() {
            // Use the number of tabs based on the totalTabs variable
            if (this.touchEndX < this.touchStartX - 50) {
                this.activeTab = (this.activeTab + 1) % this.totalTabs;
            } else if (this.touchEndX > this.touchStartX + 50) {
                this.activeTab = (this.activeTab - 1 + this.totalTabs) % this.totalTabs;
            }
        },
        
        init() {
            this.calculateWidth();
            this.calculateWidthMobile();

            window.addEventListener('resize', () => {
                this.calculateWidth();
                this.calculateWidthMobile();
            });

            const observer = new IntersectionObserver((entries) => {
                const visibleTabs = new Set();
                entries.forEach(entry => {
                    const key = parseInt(entry.target.getAttribute('x-ref').replace('tab', ''), 10);
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        visibleTabs.add(key);
                    } else {
                        visibleTabs.delete(key);
                    }
                });

                if (visibleTabs.size > 0) {
                    this.activeTab = Math.min(...visibleTabs);
                }
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            });

            this.$nextTick(() => {
                const container = this.$refs.container;
                const mobileContainer = this.$refs.mobileContainer;

                if (container) {
                    container.querySelectorAll('.tab-control').forEach(tab => observer.observe(tab));
                    container.addEventListener('touchstart', this.handleTouchStart.bind(this));
                    container.addEventListener('touchend', this.handleTouchEnd.bind(this));
                }

                if (mobileContainer) {
                    mobileContainer.querySelectorAll('.tab-control').forEach(tab => observer.observe(tab));
                }

                const initialVisibleTab = Array.from(container.querySelectorAll('.tab-control')).find(tab => {
                    const rect = tab.getBoundingClientRect();
                    return rect.left >= 0 && rect.right <= window.innerWidth;
                });

                if (initialVisibleTab) {
                    this.activeTab = parseInt(initialVisibleTab.getAttribute('x-ref').replace('tab', ''), 10);
                } else {
                    this.activeTab = 0;
                }
            });
        }
    }));
});


document.addEventListener('alpine:init', () => {
    Alpine.data('tabbedImageVideoTab', () => ({
        videoType: "upload",
        video: null,
        videoPlaying: false,

        init() {
            this.video = this.$root.querySelector("video") || this.$root.querySelector("iframe");
    
            if (!this.video) {
                console.error('Video not found in the component');
                return;
            }
    
            if (this.video.classList.contains("video-embed")) {
                this.videoType = "embed";
            }
        },
    
        playVideo() {
            if (this.videoType === "upload") {
                this.video.play();
                this.$refs.videoPlay.classList.add("hidden");
                this.$refs.videoPause.classList.remove("hidden");
                setTimeout(() => {
                    this.videoPlaying = true;
                }, 500);
                return;
            }
    
            if (this.videoType === "embed") {
                const currentSrc = this.video.src;
    
                const currentSrcArray = currentSrc.split("&");
                let newSrc = "";
    
                currentSrcArray.forEach((part) => {
                    if (part.includes("autoplay=")) {
                        part = "autoplay=1";
                    }
                    newSrc += part + "&";
                });
    
                this.video.src = newSrc;

                this.$refs.videoPlay.classList.add("hidden");
                this.$refs.videoPause.classList.remove("hidden"); 
            }
    
            setTimeout(() => {
                this.videoPlaying = true;
            }, 1000);
        },

        pauseVideo() {
            if (this.videoType === "upload") {
                this.video.pause();
                this.videoPlaying = false;
                this.$refs.videoPlay.classList.remove("hidden");
                this.$refs.videoPause.classList.add("hidden");
                return;
            }

            if (this.videoType === "embed") {
                const currentSrc = this.video.src;
                const currentSrcArray = currentSrc.split("&");
                let newSrc = "";

                currentSrcArray.forEach((part) => {
                    if (part.includes("autoplay=")) {
                        part = "autoplay=0";  // Disable autoplay to pause
                    }
                    newSrc += part + "&";
                });

                this.video.src = newSrc;
                this.$refs.videoPlay.classList.remove("hidden");
                this.$refs.videoPause.classList.add("hidden");
            }

            this.videoPlaying = false;
        }
    }));
});
